<div [ngClass]="isEmbedded ? '' : 'mb-8 p-4 md:p-6 max-w-5xl mx-auto'">
  <!-- Header -->
  @if (!isEmbedded) {
  <div class="mb-6">
    <app-btn-back routeTo=".." icon="fa fa-arrow-left" btnText="Back to Community"></app-btn-back>
    <div class="flex justify-between items-center mt-4">
      <h1 class="text-2xl font-extrabold text-blueGray-800 tracking-tight">Funding Requests</h1>
      @if (isTreasurer || isAdmin) {
      <app-btn-action (clicked)="showFundingModal = true" [shadow]="false" [isDisabled]="fundingList.length >= 5"
        label="Create Request" icon="fa fa-plus" bgColor="bg-transparent hover:bg-gray-200 active:bg-gray-200"
        textColor="text-primary-300 hover:text-primary-500 active:text-primary-500"></app-btn-action>
      }
    </div>
  </div>
  } @else {
  <div class="flex flex-row justify-between items-center mb-4">
    <h3 class="text-lg font-bold text-gray-800">
      Active Funding Requests ({{ fundingList.length }} / 5)
    </h3>
    @if (isTreasurer || isAdmin) {
    <app-btn-action (clicked)="showFundingModal = true" [shadow]="false" [isDisabled]="fundingList.length >= 5"
      label="Create Request" icon="fa fa-plus" bgColor="bg-transparent hover:bg-gray-200 active:bg-gray-200"
      textColor="text-primary-300 hover:text-primary-500 active:text-primary-500"></app-btn-action>
    }
  </div>
  }

  <!-- Donation Details Picker Modal Overlay -->
  @if (selectedFunding) {
  <div class="fixed inset-0 bg-blueGray-900 bg-opacity-50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
    <div
      class="bg-white rounded-2xl max-w-md w-full shadow-2xl p-6 border border-blueGray-100 relative animate-in fade-in zoom-in duration-200">
      <button (click)="cancelDonation()"
        class="absolute right-4 top-4 text-blueGray-400 hover:text-blueGray-600 focus:outline-none">
        <i class="fa fa-times text-lg"></i>
      </button>

      <span class="text-xs font-bold uppercase tracking-wider text-indigo-500">Support Fund</span>
      <h3 class="text-xl font-bold text-blueGray-800 mt-1 mb-2">{{ selectedFunding.title }}</h3>
      <p class="text-xs text-blueGray-500 mb-6 leading-relaxed">{{ selectedFunding.description }}</p>

      <form [formGroup]="pageForm" (ngSubmit)="donate()" class="flex flex-col gap-4">
        <!-- Currency -->
        <div>
          <label class="block text-xs font-semibold uppercase text-blueGray-500 mb-1">Currency</label>
          <div
            class="w-full rounded-lg border border-blueGray-200 bg-blueGray-100 p-2.5 text-sm text-blueGray-600 font-semibold select-none">
            {{ (group?.currency || 'USD') | uppercase }} (Church Base Currency)
          </div>
        </div>

        <!-- Amount -->
        <div>
          <label class="block text-xs font-semibold uppercase text-blueGray-500 mb-1">Amount</label>
          <div class="relative">
            <span class="absolute left-3 top-2.5 text-blueGray-500 text-sm font-semibold">{{ getCurrencySymbol()
              }}</span>
            <input type="number" formControlName="amount" placeholder="0.00"
              class="w-full pl-7 pr-3 py-2.5 rounded-lg border border-blueGray-200 bg-blueGray-50 text-sm text-blueGray-700 focus:border-indigo-500 focus:outline-none" />
          </div>
          @if (pageForm.get('amount')?.invalid && pageForm.get('amount')?.touched) {
          <span class="text-xs text-red-500 mt-1">Please enter a valid amount.</span>
          }
        </div>

        <!-- Frequency -->
        <div>
          <label class="block text-xs font-semibold uppercase text-blueGray-500 mb-2">Frequency</label>
          <div class="grid grid-cols-2 gap-2">
            <label
              class="cursor-pointer flex items-center justify-center p-2.5 rounded-lg border text-sm font-semibold transition-all"
              [ngClass]="pageForm.value.mode === 'payment' ? 'border-indigo-500 bg-indigo-50 text-indigo-700' : 'border-blueGray-200 text-blueGray-600 hover:bg-blueGray-50'">
              <input type="radio" formControlName="mode" value="payment" class="sr-only" />
              One-time
            </label>
            <label
              class="cursor-pointer flex items-center justify-center p-2.5 rounded-lg border text-sm font-semibold transition-all"
              [ngClass]="pageForm.value.mode === 'subscription' ? 'border-indigo-500 bg-indigo-50 text-indigo-700' : 'border-blueGray-200 text-blueGray-600 hover:bg-blueGray-50'">
              <input type="radio" formControlName="mode" value="subscription" class="sr-only" />
              Monthly
            </label>
          </div>
        </div>

        <!-- Submit -->
        <div class="flex gap-2 mt-2">
          <button type="button" (click)="cancelDonation()"
            class="w-1/2 border border-blueGray-200 text-blueGray-600 hover:bg-blueGray-50 font-bold py-3 px-4 rounded-xl transition-all focus:outline-none">
            Cancel
          </button>
          <button type="submit" [disabled]="pageForm.invalid || isSubmitting"
            class="w-1/2 flex items-center justify-center gap-2 bg-indigo-600 hover:bg-indigo-700 disabled:bg-indigo-300 text-white font-bold py-3 px-4 rounded-xl shadow-lg transition-all focus:outline-none">
            @if (isSubmitting) {
            <i class="fa fa-spinner fa-spin mr-2"></i> Loading...
            } @else {
            <i class="fa fa-heart mr-2"></i> Donate
            }
          </button>
        </div>
      </form>
    </div>
  </div>
  }

  <!-- Funding Grid -->
  @if (fundingList.length === 0) {
  <div class="bg-white p-12 text-center text-blueGray-400 max-w-md mx-auto">
    <i class="fa fa-hand-holding-heart text-5xl text-indigo-300 mb-4"></i>
    <h3 class="text-lg font-bold text-blueGray-800 mb-1">No Active Funding Requests</h3>
    <p class="text-sm">There are no active funding requests for {{ groupName }} at the moment.</p>
  </div>
  } @else {
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
    @for (fund of fundingList; track fund.id) {
    <div
      class="bg-white border border-blueGray-100 rounded-2xl p-6 shadow-sm hover:shadow-md transition-all flex flex-col justify-between min-h-[260px]">
      <div>
        <div class="flex justify-between items-start mb-2">
          <h3 class="text-lg font-bold text-blueGray-800">{{ fund.title }}</h3>
          @if (isTreasurer || isAdmin) {
          <span class="text-xs font-semibold px-2 py-0.5 rounded-full capitalize"
            [ngClass]="fund.status === 'active' ? 'bg-emerald-100 text-emerald-800' : 'bg-gray-100 text-gray-800'">
            {{ fund.status }}
          </span>
          }
        </div>
        <p class="text-xs text-blueGray-500 mb-4 leading-relaxed line-clamp-4">{{ fund.description }}</p>
      </div>

      <div class="border-t border-blueGray-50 pt-4 mt-4">
        @let target = fund.targetAmount || 0;
        @let raised = fund.raisedAmount || 0;
        @let progressPercent = target > 0 ? (raised / target * 100) : 0;
        @let clampedProgress = progressPercent > 100 ? 100 : progressPercent;

        <div class="w-full mb-3">
          <div class="flex justify-between items-center text-xs mb-1 font-semibold">
            <span class="text-indigo-600">Progress: {{ progressPercent | number: '1.0-0' }}%</span>
            <span class="text-blueGray-500">{{ raised | currency: (group?.currency || 'USD') }} / {{ target | currency:
              (group?.currency || 'USD') }}</span>
          </div>
          <div class="w-full bg-blueGray-100 rounded-full h-2 overflow-hidden">
            <div class="bg-indigo-600 h-2 rounded-full transition-all duration-500" [style.width.%]="clampedProgress">
            </div>
          </div>
        </div>

        <div class="flex justify-between items-center mt-4">
          <div>
            <span class="text-[10px] uppercase font-semibold text-blueGray-400 block">Goal Target</span>
            <span class="text-lg font-black text-indigo-600">{{ target | currency: (group?.currency || 'USD') }}</span>
          </div>
          <button (click)="selectFundingForDonation(fund)"
            class="bg-indigo-600 hover:bg-indigo-700 text-white font-bold text-xs py-2.5 px-4 rounded-xl shadow-md hover:shadow-lg transition-all focus:outline-none">
            Support Fund
          </button>
        </div>
      </div>
    </div>
    }
  </div>
  }

  <!-- Funding Request Modal Form -->
  @if (showFundingModal) {
  <div class="fixed inset-0 bg-blueGray-900 bg-opacity-50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
    <div
      class="bg-white rounded-2xl max-w-lg w-full shadow-2xl p-6 border border-blueGray-100 relative max-h-[90vh] overflow-y-auto animate-in fade-in zoom-in duration-200">
      <button (click)="showFundingModal = false"
        class="absolute right-4 top-4 text-blueGray-400 hover:text-blueGray-600 focus:outline-none">
        <i class="fa fa-times text-lg"></i>
      </button>

      <h3 class="text-xl font-bold text-blueGray-800 mb-4">Create Funding Request</h3>

      <form [formGroup]="fundingForm" (ngSubmit)="saveFunding()" class="flex flex-col gap-4">
        <!-- Title -->
        <div>
          <label class="block text-xs font-semibold uppercase text-blueGray-500 mb-1">Title *</label>
          <input type="text" formControlName="title" placeholder="e.g. Youth Camp Sponsorship"
            class="w-full py-2.5 px-3 rounded-lg border border-blueGray-200 bg-blueGray-50 text-sm text-blueGray-700 focus:border-primary-500 focus:outline-none" />
          @if (fundingForm.get('title')?.invalid && fundingForm.get('title')?.touched) {
          <span class="text-xs text-red-500 mt-1">Please enter a valid title.</span>
          }
        </div>

        <!-- Description -->
        <div>
          <label class="block text-xs font-semibold uppercase text-blueGray-500 mb-1">Description *</label>
          <textarea formControlName="description" rows="3" placeholder="Explain what this fundraiser is for..."
            class="w-full py-2.5 px-3 rounded-lg border border-blueGray-200 bg-blueGray-50 text-sm text-blueGray-700 focus:border-primary-500 focus:outline-none"></textarea>
          @if (fundingForm.get('description')?.invalid && fundingForm.get('description')?.touched) {
          <span class="text-xs text-red-500 mt-1">Please enter a description.</span>
          }
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <!-- Goal Amount (raiseAmount) -->
          <div>
            <label class="block text-xs font-semibold uppercase text-blueGray-500 mb-1">Goal target Amount *</label>
            <input type="number" formControlName="raiseAmount" placeholder="USD"
              class="w-full py-2.5 px-3 rounded-lg border border-blueGray-200 bg-blueGray-50 text-sm text-blueGray-700 focus:border-primary-500 focus:outline-none" />
            @if (fundingForm.get('raiseAmount')?.invalid && fundingForm.get('raiseAmount')?.touched) {
            <span class="text-xs text-red-500 mt-1">Please enter a goal target amount.</span>
            }
          </div>

          <!-- Min Contribution -->
          <div>
            <label class="block text-xs font-semibold uppercase text-blueGray-500 mb-1">Min Contribution
              (Optional)</label>
            <input type="number" formControlName="minContribution" placeholder="Optional minimum amount"
              class="w-full py-2.5 px-3 rounded-lg border border-blueGray-200 bg-blueGray-50 text-sm text-blueGray-700 focus:border-primary-500 focus:outline-none" />
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <!-- End Date -->
          <div>
            <label class="block text-xs font-semibold uppercase text-blueGray-500 mb-1">End Date *</label>
            <input type="date" formControlName="endDate"
              class="w-full py-2.5 px-3 rounded-lg border border-blueGray-200 bg-blueGray-50 text-sm text-blueGray-700 focus:border-primary-500 focus:outline-none" />
            @if (fundingForm.get('endDate')?.invalid && fundingForm.get('endDate')?.touched) {
            <span class="text-xs text-red-500 mt-1">Please enter a valid end date.</span>
            }
          </div>

          <!-- Visibility (isPublic) -->
          <div>
            <label class="block text-xs font-semibold uppercase text-blueGray-500 mb-1">Campaign Visibility *</label>
            <select formControlName="isPublic"
              class="w-full rounded-lg border border-blueGray-200 bg-blueGray-50 p-2.5 text-sm text-blueGray-700 focus:border-primary-500 focus:outline-none">
              <option [ngValue]="true">Public (Visible to all users)</option>
              <option [ngValue]="false">Private (Only group members)</option>
            </select>
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <!-- Requester Name -->
          <div>
            <label class="block text-xs font-semibold uppercase text-blueGray-500 mb-1">Requester Name *</label>
            <input type="text" formControlName="requesterName" placeholder="e.g. Jane Doe"
              class="w-full py-2.5 px-3 rounded-lg border border-blueGray-200 bg-blueGray-50 text-sm text-blueGray-700 focus:border-primary-500 focus:outline-none" />
            @if (fundingForm.get('requesterName')?.invalid && fundingForm.get('requesterName')?.touched) {
            <span class="text-xs text-red-500 mt-1">Please enter requester name.</span>
            }
          </div>

          <!-- Requester Contact -->
          <div>
            <label class="block text-xs font-semibold uppercase text-blueGray-500 mb-1">Requester Contact *</label>
            <input type="text" formControlName="requesterContact" placeholder="e.g. Email/Phone"
              class="w-full py-2.5 px-3 rounded-lg border border-blueGray-200 bg-blueGray-50 text-sm text-blueGray-700 focus:border-primary-500 focus:outline-none" />
            @if (fundingForm.get('requesterContact')?.invalid && fundingForm.get('requesterContact')?.touched) {
            <span class="text-xs text-red-500 mt-1">Please enter requester contact.</span>
            }
          </div>
        </div>

        <!-- Attachment Upload (image/document) -->
        <div>
          <label class="block text-xs font-semibold uppercase text-blueGray-500 mb-1">Attachment (Image or Document,
            Max 5MB)</label>
          <input type="file" (change)="onFundingFileSelected($event)" accept="image/*,application/pdf"
            class="w-full text-sm text-blueGray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-xs file:font-semibold file:bg-primary-50 file:text-primary-600 hover:file:bg-primary-100" />
          @if (fundingFile) {
          <div class="text-xs text-emerald-600 mt-1 flex items-center gap-1">
            <i class="fa fa-circle-check"></i> File selected: {{ fundingFile.name }} ({{ (fundingFile.size / 1024 /
            1024) | number:'1.1-2' }} MB)
          </div>
          }
        </div>

        <!-- Submit buttons -->
        <div class="flex gap-3 justify-end mt-4">
          <button type="button" (click)="showFundingModal = false"
            class="bg-blueGray-100 hover:bg-blueGray-200 text-blueGray-700 font-bold py-2.5 px-4 rounded-xl text-sm transition-all focus:outline-none">
            Cancel
          </button>
          <button type="submit" [disabled]="fundingForm.invalid || isSubmittingFunding"
            class="flex items-center gap-2 bg-primary-500 hover:bg-primary-600 disabled:bg-primary-300 text-white font-bold py-2.5 px-5 rounded-xl shadow-lg transition-all focus:outline-none">
            @if (isSubmittingFunding) {
            <i class="fa fa-spinner fa-spin"></i> Saving...
            } @else {
            <i class="fa fa-save"></i> Save Funding Request
            }
          </button>
        </div>
      </form>
    </div>
  </div>
  }
</div>